import React from 'react';
import PropTypes from 'prop-types';

import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './VideoSerie.module.scss';
import i18nStrings from './VideoSerie.i18n.json';
import {SectionLayout} from '~/src/utilities/constants/layout';
import Teaser from '~/src/components/teaser/Teaser';
import {TeaserFormat} from '~/src/utilities/constants/formats';
import SectionContextProvider from '~/src/components/context/SectionContext';
import VideoSeriesCarousel from '~/src/components/video/series/carousel/VideoSeriesCarousel';

const getTranslation = initPolyglot(i18nStrings);

class VideoSerie extends React.Component {
    constructor(props) {
        super(props);

        let carouselStartPos = 0;
        const carouselChildren = this.props.videos.map((teaser, index) => {
            let isSelected = false;
            if (this.props.currentVideoId.toString() === teaser.id.toString()) {
                carouselStartPos = index;
                isSelected = true;
            }
            return <Teaser key={index} {...teaser} isSelected={isSelected} format={TeaserFormat.TEASER_SERIES} />;
        });

        this.state = {
            carouselStartPos,
            carouselChildren
        };
    }

    render() {
        return (
            <React.Fragment>
                <div className={css.videoSeriesTitle}>{getTranslation('moreEpisodes')}</div>
                <SectionContextProvider value={{layout: SectionLayout.CAROUSEL_VIDEO_SERIES}}>
                    <VideoSeriesCarousel carouselStartPos={this.state.carouselStartPos}>{this.state.carouselChildren}</VideoSeriesCarousel>
                </SectionContextProvider>
            </React.Fragment>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    VideoSerie.propTypes = {
        videos: PropTypes.shape({
            id: PropTypes.number
        }),
        currentVideoId: PropTypes.number
    };
}

export default VideoSerie;
